import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true, // Explicitly enable thunk (not necessary but good practice)
      serializableCheck: false, // Prevents warnings for non-serializable values in actions
    }).concat(thunk), // Manually adding thunk (optional)
  devTools: process.env.NODE_ENV !== "production", // Enables Redux DevTools only in development
});

export default store;
